import Icon from '../components/Icon.vue'

Icon.register({"headphones":{"width":512,"height":512,"paths":[{"d":"M256 32C114.5 32 0 146.5 0 288V336A32-32 0 0 1 17.7 364.6L32.1 371.8C34.1 431.9 83.4 480 144 480H168C181.3 480 192 469.3 192 456V280C192 266.7 181.3 256 168 256H144C112.7 256 84.3 268.9 64 289.6V288C64 182.1 150.1 96 256 96S448 182.1 448 288V289.6C427.7 268.9 399.3 256 368 256H344C330.7 256 320 266.7 320 280V456C320 469.3 330.7 480 344 480H368C428.6 480 477.9 431.9 479.9 371.8L494.3 364.6A32-32 0 0 1 512 336V288C512 146.5 397.5 32 256 32z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/headphones.js
// module id = null
// module chunks = 